import { useCurrentOrganization } from '@/composables/useCurrentOrganization'
import { collection, query, where, getDocs, addDoc, updateDoc, deleteDoc, doc, QueryConstraint } from 'firebase/firestore'
import { db } from '@/firebase/config'
import { useCurrentOrganizationStore } from '@/stores/currentOrganization'

export class BaseStore {
  protected collectionName: string
  private currentOrganizationStore: any

  constructor(collectionName: string) {
    this.collectionName = collectionName
    this.currentOrganizationStore = useCurrentOrganizationStore()
  }

  protected get organizationId(): string {
    return this.currentOrganizationStore.currentOrganization?.id
  }

  protected async fetchCollection<T>(extraFilters: QueryConstraint[] = []) {
    if (!this.organizationId) throw new Error('Organização não selecionada')

    const baseQuery = query(
      collection(db, this.collectionName),
      where('organizationId', '==', this.organizationId),
      ...extraFilters
    )

    const snapshot = await getDocs(baseQuery)
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as T[]
  }

  protected async addDocument<T>(data: Omit<T, 'organizationId' | 'active' | 'createdAt' | 'updatedAt'>) {
    if (!this.organizationId) throw new Error('Organização não selecionada')

    const docRef = await addDoc(collection(db, this.collectionName), {
      ...data,
      organizationId: this.organizationId,
      active: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    })

    return {
      id: docRef.id,
      ...data,
      organizationId: this.organizationId,
      active: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }
  }

  protected async updateDocument<T>(id: string, data: Partial<T>) {
    if (!this.organizationId) throw new Error('Organização não selecionada')

    const docRef = doc(db, this.collectionName, id)
    await updateDoc(docRef, {
      ...data,
      updatedAt: new Date().toISOString()
    })

    return {
      id,
      ...data
    }
  }

  protected async deleteDocument(id: string) {
    if (!this.organizationId) throw new Error('Organização não selecionada')

    // Deleta o documento diretamente
    const docRef = doc(db, this.collectionName, id)
    await deleteDoc(docRef)
  }
}
